export default "__VITE_ASSET__DsSAElNx__"